var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { getClient, initializeClient } from '../../clients/link-api';
import { getLinkApiTemplateType } from '../../LinkApiRouter/utils/link-api-response';
import { updateEmployerOrPlatform } from '../../tracking/datadog';
import { selectFeatureFlags, selectRequiredJobs, selectExperiments, } from './slice-link-params';
import { isAdp, isAdpPartnership } from '../../consts/platforms';
export var initialState = {
    loading: false,
    linkApiResponses: [],
    context: null,
    accountId: null,
    jobType: null,
    formSubtype: null,
    loginAttemptId: null,
    isInAccountRecovery: false,
    ddsResponse: null,
    hasAttemptedDDS: false,
    eligibilityCheck: null,
    usingMultiSupplierEligibility: false,
    latestAppClipEvent: null,
};
export var initializeLogin = createAsyncThunk('linkApi/initializeLogin', function (_a) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, idObject = _a.idObject, sdk = _a.sdk, sdkVersion = _a.sdkVersion;
    return __awaiter(void 0, void 0, void 0, function () {
        var loginAttemptId, client, context, linkApiResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    loginAttemptId = v4();
                    client = initializeClient(linkToken, uniqueUserId, {
                        __headers: {
                            modal_session_id: modalSessionId,
                            login_attempt_id: loginAttemptId,
                            'x-sdk': sdk,
                            'x-sdk-version': sdkVersion,
                        },
                    });
                    return [4 /*yield*/, client.getInitializationContext(idObject)];
                case 1:
                    context = _b.sent();
                    updateEmployerOrPlatform({
                        employer: context.employer,
                        platform: context.platform,
                    });
                    return [4 /*yield*/, client.initializeLogin(idObject)];
                case 2:
                    linkApiResponse = _b.sent();
                    return [2 /*return*/, {
                            context: context,
                            linkApiResponse: linkApiResponse,
                            loginAttemptId: loginAttemptId,
                        }];
            }
        });
    });
});
export var updateInitializationContext = createAsyncThunk('linkApi/updateInitializationContext', function (idObject) { return __awaiter(void 0, void 0, void 0, function () {
    var client, context;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = getClient();
                return [4 /*yield*/, client.getInitializationContext(idObject)];
            case 1:
                context = _a.sent();
                updateEmployerOrPlatform({
                    employer: context.employer,
                    platform: context.platform,
                });
                return [2 /*return*/, {
                        context: context,
                    }];
        }
    });
}); });
export var initializeDDS = createAsyncThunk('linkApi/initializeDDS', function (_a) {
    var amountSelection = _a.amountSelection, bankInfo = _a.bankInfo, maskedAccountId = _a.maskedAccountId;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, linkApiResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = getClient();
                    return [4 /*yield*/, client.initializeDD(amountSelection, bankInfo, maskedAccountId)];
                case 1:
                    linkApiResponse = _b.sent();
                    return [2 /*return*/, {
                            linkApiResponse: linkApiResponse,
                        }];
            }
        });
    });
});
export var next = createAsyncThunk('linkApi/next', function (_a) {
    var payload = _a.payload, encryptionInfo = _a.encryptionInfo;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, linkApiResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = getClient();
                    return [4 /*yield*/, client.submitStep(payload, encryptionInfo)];
                case 1:
                    linkApiResponse = _b.sent();
                    return [2 /*return*/, {
                            linkApiResponse: linkApiResponse,
                        }];
            }
        });
    });
});
export var postUserAuthenticationFields = createAsyncThunk('linkApi/postUserAuthenticationFields', function (_a) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, sdk = _a.sdk, sdkVersion = _a.sdkVersion, data = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, linkApiResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = initializeClient(linkToken, uniqueUserId, {
                        __headers: {
                            modal_session_id: modalSessionId,
                            'x-sdk': sdk,
                            'x-sdk-version': sdkVersion,
                        },
                    });
                    return [4 /*yield*/, client.postUserAuthenticationFields({
                            social_security_number_last_four: data.social_security_number_last_four,
                            date_of_birth: data.date_of_birth,
                            mobile_phone_number: data.mobile_phone_number,
                        })];
                case 1:
                    linkApiResponse = _b.sent();
                    return [2 /*return*/, {
                            linkApiResponse: linkApiResponse,
                        }];
            }
        });
    });
});
export var waitForJobStepResults = createAsyncThunk('linkApi/waitForJobStepsResults', function () { return __awaiter(void 0, void 0, void 0, function () {
    var client, linkApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = getClient();
                return [4 /*yield*/, client.waitForStepResult()];
            case 1:
                linkApiResponse = _a.sent();
                return [2 /*return*/, {
                        linkApiResponse: linkApiResponse,
                    }];
        }
    });
}); });
export var initializeCardSwitch = createAsyncThunk('linkApi/initializeCardSwitch', function () { return __awaiter(void 0, void 0, void 0, function () {
    var client, linkApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = getClient();
                return [4 /*yield*/, client.initializeCardSwitch()];
            case 1:
                linkApiResponse = _a.sent();
                return [2 /*return*/, {
                        linkApiResponse: linkApiResponse,
                    }];
        }
    });
}); });
export var initializeBillSwitch = createAsyncThunk('linkApi/initializeBillSwitch', function () { return __awaiter(void 0, void 0, void 0, function () {
    var client, linkApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = getClient();
                return [4 /*yield*/, client.initializeBillSwitch()];
            case 1:
                linkApiResponse = _a.sent();
                return [2 /*return*/, {
                        linkApiResponse: linkApiResponse,
                    }];
        }
    });
}); });
export var initializeBillCancellation = createAsyncThunk('linkApi/initializeBillCancellation', function () { return __awaiter(void 0, void 0, void 0, function () {
    var client, linkApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = getClient();
                return [4 /*yield*/, client.initializeBillCancellation()];
            case 1:
                linkApiResponse = _a.sent();
                return [2 /*return*/, {
                        linkApiResponse: linkApiResponse,
                    }];
        }
    });
}); });
export var initializeMultiSupplierEligibility = createAsyncThunk('linkApi/initializeMultiSupplierEligibility', function (_a) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, sdk = _a.sdk, sdkVersion = _a.sdkVersion;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, sessionStatusResponse, eligibilityCheck;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = initializeClient(linkToken, uniqueUserId, {
                        __headers: {
                            modal_session_id: modalSessionId,
                            'x-sdk': sdk,
                            'x-sdk-version': sdkVersion,
                        },
                    });
                    return [4 /*yield*/, client.getSessionStatus()];
                case 1:
                    sessionStatusResponse = _b.sent();
                    if (!('error' in sessionStatusResponse)) return [3 /*break*/, 3];
                    return [4 /*yield*/, client.postEligibilityCheck()];
                case 2:
                    eligibilityCheck = _b.sent();
                    return [2 /*return*/, {
                            eligibilityCheck: eligibilityCheck,
                        }];
                case 3: return [2 /*return*/, {
                        sessionStatusResponse: sessionStatusResponse,
                    }];
            }
        });
    });
});
export var acceptTerms = createAsyncThunk('linkApi/acceptTerms', function (_a) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, sdk = _a.sdk, sdkVersion = _a.sdkVersion;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, linkApiResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = initializeClient(linkToken, uniqueUserId, {
                        __headers: {
                            modal_session_id: modalSessionId,
                            'x-sdk': sdk,
                            'x-sdk-version': sdkVersion,
                        },
                    });
                    return [4 /*yield*/, client.acceptTerms()];
                case 1:
                    linkApiResponse = _b.sent();
                    return [2 /*return*/, {
                            linkApiResponse: linkApiResponse,
                        }];
            }
        });
    });
});
export var MSE_POLLING_INITIALIZE = "linkApi/multiSupplierEligibility/pollingInitialize";
export var MSE_POLLING_UPDATE = "linkApi/multiSupplierEligibility/pollingUpdate";
export var MSE_POLLING_SUSPENDED = "linkApi/multiSupplierEligibility/pollingSuspended";
export var MSE_POLLING_FULFILLED = "linkApi/multiSupplierEligibility/pollingFulfilled";
export var APP_CLIP_EVENT_LATEST_RELEVANT_EVENT = "linkApi/appClipEvent/event";
export var linkApiSlice = createSlice({
    name: 'linkApi',
    initialState: initialState,
    reducers: {
        changeLoadedPlatform: function (state, action) { return (__assign(__assign({}, state), { context: __assign(__assign({}, state.context), { platform: action.payload }) })); },
        setDdsResponse: function (state, ddsResponse) { return (__assign(__assign({}, state), { ddsResponse: ddsResponse.payload })); },
        setIsBackgroundIdentify: function (state, isBackgroundIdentify) { return (__assign(__assign({}, state), { isBackgroundIdentify: isBackgroundIdentify.payload })); },
        setEligibilityCheckResponse: function (state, eligibilityCheck) { return (__assign(__assign({}, state), { eligibilityCheck: eligibilityCheck.payload })); },
        setUsingMultiSupplierEligibility: function (state, usingMultiSupplierEligibility) { return (__assign(__assign({}, state), { usingMultiSupplierEligibility: usingMultiSupplierEligibility.payload })); },
        clearLinkApiResponses: function (state) { return (__assign(__assign({}, state), { linkApiResponses: [] })); },
        clearSessionStatusResponse: function (state) { return (__assign(__assign({}, state), { sessionStatusResponse: null })); },
        setSelectedMaskedAccountId: function (state, selectedMaskedAccountId) { return (__assign(__assign({}, state), { selectedMaskedAccountId: selectedMaskedAccountId.payload })); },
        setMaskedAccounts: function (state, maskedAccounts) { return (__assign(__assign({}, state), { maskedAccounts: maskedAccounts.payload })); },
    },
    extraReducers: function (builder) {
        builder.addCase(initializeLogin.pending, function (state) {
            return __assign(__assign({}, state), { jobType: 'login', loading: true, isInAccountRecovery: false });
        });
        builder.addCase(initializeLogin.fulfilled, function (state, action) {
            var _a = action.payload, context = _a.context, linkApiResponse = _a.linkApiResponse, loginAttemptId = _a.loginAttemptId;
            return __assign(__assign({}, state), { jobType: 'login', loginAttemptId: loginAttemptId, loading: false, linkApiResponses: [linkApiResponse], accountId: action.payload.linkApiResponse.responseType === 'success'
                    ? action.payload.linkApiResponse.accountId
                    : null, context: context, maskedAccounts: action.payload.linkApiResponse.responseType === 'success'
                    ? action.payload.linkApiResponse.maskedAccounts
                    : null });
        });
        builder.addCase(initializeDDS.pending, function (state) { return (__assign(__assign({}, state), { jobType: 'direct_deposit_switch', loading: true, linkApiResponses: [], hasAttemptedDDS: true })); });
        builder.addCase(initializeDDS.fulfilled, function (state, action) {
            var linkApiResponse = action.payload.linkApiResponse;
            return __assign(__assign({}, state), { jobType: 'direct_deposit_switch', loading: false, linkApiResponses: [linkApiResponse] });
        });
        builder.addCase(next.pending, function (state, action) {
            return __assign(__assign({}, state), { loading: true, isInAccountRecovery: state.isInAccountRecovery ||
                    'account_recovery_step_key' in (action.meta.arg.payload || {}) });
        });
        builder.addCase(next.fulfilled, function (state, action) {
            var copy = __spreadArray([], state.linkApiResponses, true);
            if (action.payload.linkApiResponse.responseType === 'next_with_error')
                copy.shift();
            return __assign(__assign({}, state), { loading: false, ddsResponse: state.jobType === 'direct_deposit_switch'
                    ? action.payload.linkApiResponse
                    : null, accountId: action.payload.linkApiResponse.responseType === 'success'
                    ? action.payload.linkApiResponse.accountId
                    : null, linkApiResponses: __spreadArray([action.payload.linkApiResponse], copy, true), maskedAccounts: action.payload.linkApiResponse.responseType === 'success'
                    ? action.payload.linkApiResponse.maskedAccounts
                    : null });
        });
        builder.addCase(waitForJobStepResults.pending, function (state) { return (__assign({}, state)); });
        builder.addCase(waitForJobStepResults.fulfilled, function (state, action) { return (__assign(__assign({}, state), { loading: false, ddsResponse: state.jobType === 'direct_deposit_switch'
                ? action.payload.linkApiResponse
                : state.ddsResponse, accountId: action.payload.linkApiResponse.responseType === 'success'
                ? action.payload.linkApiResponse.accountId
                : null, linkApiResponses: __spreadArray([
                action.payload.linkApiResponse
            ], state.linkApiResponses, true), maskedAccounts: action.payload.linkApiResponse.responseType === 'success'
                ? action.payload.linkApiResponse.maskedAccounts
                : null })); });
        builder.addCase(initializeBillSwitch.pending, function (state) { return (__assign(__assign({}, state), { jobType: 'bill_switch', loading: true, linkApiResponses: [] })); });
        builder.addCase(initializeBillSwitch.fulfilled, function (state, action) { return (__assign(__assign({}, state), { jobType: 'bill_switch', loading: false, linkApiResponses: [action.payload.linkApiResponse] })); });
        builder.addCase(initializeBillCancellation.pending, function (state) { return (__assign(__assign({}, state), { jobType: 'bill_cancellation', loading: true, linkApiResponses: [] })); });
        builder.addCase(initializeBillCancellation.fulfilled, function (state, action) { return (__assign(__assign({}, state), { jobType: 'bill_cancellation', loading: false, linkApiResponses: [action.payload.linkApiResponse] })); });
        builder.addCase(initializeCardSwitch.pending, function (state) { return (__assign(__assign({}, state), { jobType: 'card_switch', loading: true, linkApiResponses: [] })); });
        builder.addCase(initializeCardSwitch.fulfilled, function (state, action) { return (__assign(__assign({}, state), { jobType: 'card_switch', loading: false, linkApiResponses: [action.payload.linkApiResponse] })); });
        builder.addCase(updateInitializationContext.pending, function (state) { return (__assign({}, state)); });
        builder.addCase(updateInitializationContext.fulfilled, function (state, action) { return (__assign(__assign({}, state), { context: action.payload.context })); });
        builder.addCase(initializeMultiSupplierEligibility.pending, function (state) { return (__assign(__assign({}, state), { eligibilityCheck: {
                isProcessing: true,
                matchedPlatforms: [],
            } })); });
        builder.addCase(postUserAuthenticationFields.pending, function (state) { return (__assign(__assign({}, state), { loading: true })); });
        builder.addCase(postUserAuthenticationFields.fulfilled, function (state, action) { return (__assign(__assign({}, state), { loading: false, linkApiResponses: [action.payload.linkApiResponse] })); });
        builder.addCase(postUserAuthenticationFields.rejected, function (state, action) { return (__assign(__assign({}, state), { error: action.error, loading: false })); });
        builder.addCase(initializeMultiSupplierEligibility.fulfilled, function (state, action) {
            var _a, _b, _c, _d, _e;
            return __assign(__assign(__assign(__assign({}, state), { eligibilityCheck: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.eligibilityCheck, sessionStatusResponse: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.sessionStatusResponse }), (((_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.sessionStatusResponse) === null || _d === void 0 ? void 0 : _d.sessionStatusData)
                ? {
                    linkApiResponses: [
                        (_e = action.payload) === null || _e === void 0 ? void 0 : _e.sessionStatusResponse.sessionStatusData,
                    ],
                    context: {
                        platform: action.payload.sessionStatusResponse.platform,
                    },
                    isBackgroundIdentify: true,
                    jobType: 'login',
                }
                : null)), { loading: false });
        });
        builder.addCase(MSE_POLLING_UPDATE, function (state, action) { return (__assign(__assign({}, state), { eligibilityCheck: action.payload })); });
        builder.addCase(MSE_POLLING_FULFILLED, function (state, action) { return (__assign(__assign({}, state), { eligibilityCheck: action.payload })); });
        builder.addCase(APP_CLIP_EVENT_LATEST_RELEVANT_EVENT, function (state, action) { return (__assign(__assign({}, state), { latestAppClipEvent: action.payload })); });
    },
});
export var changeLoadedPlatform = (_a = linkApiSlice.actions, _a.changeLoadedPlatform), setDdsResponse = _a.setDdsResponse, setEligibilityCheckResponse = _a.setEligibilityCheckResponse, setUsingMultiSupplierEligibility = _a.setUsingMultiSupplierEligibility, clearLinkApiResponses = _a.clearLinkApiResponses, clearSessionStatusResponse = _a.clearSessionStatusResponse, setIsBackgroundIdentify = _a.setIsBackgroundIdentify, setSelectedMaskedAccountId = _a.setSelectedMaskedAccountId, setMaskedAccounts = _a.setMaskedAccounts;
export var selectLoading = function (state) { return state.linkApi.loading; };
export var selectAccountId = function (state) {
    return state.linkApi.accountId;
};
export var selectLinkApiResponses = function (state) {
    return state.linkApi.linkApiResponses;
};
export var selectLinkApiResponse = function (state) {
    return state.linkApi.linkApiResponses[0];
};
export var selectEmployerFromContext = function (state) { var _a; return (_a = state.linkApi.context) === null || _a === void 0 ? void 0 : _a.employer; };
export var selectLoadedPlatform = function (state) { var _a; return (_a = state.linkApi.context) === null || _a === void 0 ? void 0 : _a.platform; };
export var selectPlatformId = function (state) { var _a, _b; return (_b = (_a = state.linkApi.context) === null || _a === void 0 ? void 0 : _a.platform) === null || _b === void 0 ? void 0 : _b.id; };
export var selectPublicKey = function (state) { var _a; return (_a = state.linkApi.context) === null || _a === void 0 ? void 0 : _a.publicKey; };
export var selectLinkApi = function (state) { return state.linkApi; };
export var selectLoginAttemptId = function (state) {
    return state.linkApi.loginAttemptId;
};
export var selectJobType = function (state) { return state.linkApi.jobType; };
export var selectIsInAccountRecovery = function (state) {
    return state.linkApi.isInAccountRecovery;
};
export var selectDdsResponse = function (state) {
    return state.linkApi.ddsResponse;
};
export var selectMatchedPlatforms = function (state) { var _a; return ((_a = state.linkApi.eligibilityCheck) === null || _a === void 0 ? void 0 : _a.matchedPlatforms) || []; };
export var selectProcessingEligibilityCheck = function (state) { var _a; return (_a = state.linkApi.eligibilityCheck) === null || _a === void 0 ? void 0 : _a.isProcessing; };
export var selectSessionStatusResponse = function (state) {
    return state.linkApi.sessionStatusResponse;
};
export var selectIsBackgroundIdentify = function (state) {
    return !!state.linkApi.isBackgroundIdentify;
};
export var selectSelectedMaskedAccountId = function (state) {
    return state.linkApi.selectedMaskedAccountId;
};
export var selectLatestAppClipEvent = function (state) {
    return state.linkApi.latestAppClipEvent;
};
export var selectSelectedMaskedAccount = function (state) {
    var _a;
    return (_a = state.linkApi.maskedAccounts) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
        var id = _a.id;
        return id === state.linkApi.selectedMaskedAccountId;
    });
};
export var selectMaskedAccounts = function (state) {
    return state.linkApi.maskedAccounts || [];
};
export var selectIsLoginDefaultStep = createSelector([selectJobType, selectLinkApiResponses], function (jobType, linkApiResponses) {
    if (jobType !== 'login')
        return false;
    var count = 0;
    for (var _i = 0, linkApiResponses_1 = linkApiResponses; _i < linkApiResponses_1.length; _i++) {
        var response = linkApiResponses_1[_i];
        var templateType = getLinkApiTemplateType(response);
        if (templateType === 'form')
            count++;
        if (count > 1)
            return false;
    }
    return count === 1;
});
export var selectIsEligibleForAdp = createSelector([selectMatchedPlatforms], function (matchedPlatforms) {
    return matchedPlatforms.some(function (_a) {
        var platform = _a.platform;
        return isAdpPartnership(platform.id);
    });
});
export var selectUsingMultiSupplierEligibility = function (state) {
    return state.linkApi.usingMultiSupplierEligibility;
};
// Returns whether the user has seen a login form yet. Note that this will
// return false when the first login form is being loaded (e.g. when a provider
// is selected from search).
export var selectIsOnOrAfterLoginFormStep = createSelector([selectJobType, selectLinkApiResponses], function (jobType, linkApiResponses) {
    if (jobType !== 'login')
        return false;
    return linkApiResponses.some(function (response) { return getLinkApiTemplateType(response) === 'form'; });
});
export var selectHasAttemptedDDS = function (state) {
    return state.linkApi.hasAttemptedDDS;
};
export var selectManualInstructions = createSelector([selectLinkApiResponse], function (linkApiResponse) {
    linkApiResponse = linkApiResponse;
    return linkApiResponse.template &&
        linkApiResponse.template.templateType === 'manual_instructions'
        ? linkApiResponse.template.textList
        : [];
});
export var selectBankInfosForManualInstructions = createSelector([selectLinkApiResponse], function (linkApiResponse) {
    if (linkApiResponse.responseType === 'next' ||
        linkApiResponse.responseType === 'next_with_error') {
        linkApiResponse = linkApiResponse;
        return linkApiResponse.template &&
            linkApiResponse.template.templateType === 'manual_instructions'
            ? linkApiResponse.template.bankInfos
            : [];
    }
    return [];
});
export var selectIsInManualInstructionsFallback = createSelector([
    selectLinkApiResponse,
    selectRequiredJobs,
    selectLoadedPlatform,
    selectFeatureFlags,
], function (linkApiResponse, requiredJobs, loadedPlatform, featureFlags) {
    if (!linkApiResponse ||
        linkApiResponse.responseType !== 'next_with_error') {
        return false;
    }
    linkApiResponse = linkApiResponse;
    return (requiredJobs.includes('direct_deposit_switch') &&
        featureFlags.adpManualInstructionsFallback &&
        linkApiResponse.template &&
        linkApiResponse.template.templateType === 'manual_instructions');
});
// TODO: CORE-1515 remove user-entered PII experiment
//
export var selectIsUserEnteredPIIStep = createSelector([selectJobType, selectLinkApiResponse, selectPlatformId, selectExperiments], function (jobType, linkApiResponse, platformId, experiments) {
    if (!experiments.expAdpUserEnteredPii ||
        jobType !== 'login' ||
        !isAdp(platformId))
        return false;
    if (linkApiResponse.responseType !== 'next' &&
        linkApiResponse.responseType !== 'next_with_error')
        return false;
    if (linkApiResponse.template.templateType !== 'form')
        return false;
    return linkApiResponse.template.fields.some(function (field) {
        return [
            'phone',
            'email',
            'social_security_number',
            'date_of_birth',
        ].includes(field.key);
    });
});
export default linkApiSlice.reducer;
